import React from 'react';
import { Power } from 'lucide-react';

export interface OnOffStyle04Props {
  isOn: boolean;
  disabled?: boolean;
  loading?: boolean;
  onToggle: () => void;
  label?: string;
}

/**
 * OnOff Style 04 - Round Button
 * Horizontal layout with label on left and rounded ON/OFF button on right
 * Shows opposite state on hover to indicate action
 */
export const Style04_RoundButton: React.FC<OnOffStyle04Props> = ({
  isOn,
  disabled = false,
  loading = false,
  onToggle,
  label = '電源開關'
}) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-slate-800/30 rounded-2xl border border-slate-700/30">
      <span className="text-sm font-medium text-slate-300">{label}</span>
      <button
        onClick={onToggle}
        disabled={disabled || loading}
        className={`group flex items-center gap-2 px-5 py-2 rounded-full font-medium text-sm transition-all ${
          isOn 
            ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30 hover:bg-red-500 hover:shadow-red-500/30' 
            : 'bg-slate-700 text-slate-400 hover:bg-green-500 hover:text-white hover:shadow-lg hover:shadow-green-500/30'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <Power className="w-4 h-4" />
        {loading ? '...' : (
          <>
            <span className="group-hover:hidden">{isOn ? 'ON' : 'OFF'}</span>
            <span className="hidden group-hover:inline">{isOn ? 'OFF' : 'ON'}</span>
          </>
        )}
      </button>
    </div>
  );
};

export default Style04_RoundButton;
